import styled from "styled-components";
import { color } from "styled-system";

const Divider = styled.div`
  height: 1px;
  ${color};
`;

export default Divider;
